import { TNeedleRequestStatus, TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST, TStoreNeedleRequest } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';
import * as moment from 'moment';
import * as _ from 'lodash';

export const LOCAL_STORE_NEEDLE_REQUESTS_LIST_TABLE_MODEL = {
  createModel(requests: TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST['needleRequests'], status: TNeedleRequestStatus) {
    return ModifiersZTableModel.createTableModel(
      requests,
      {
        padding: 8,
        headerConfig: _.compact([
          {
            type: 'TEXT_CELL',
            text: 'table_model.Date/Time',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LocationCode',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestedNeedleId',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestedQuantity',
          },
          status === 'APPROVED'
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.ApprovedNeedleIds',
              }
            : undefined,
          status === 'APPROVED'
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.ApprovedQty',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.AdditionalInfo',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item): TTableRowNode<TStoreNeedleRequest> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: _.compact([
            {
              type: 'TEXT_LIST_CELL',
              text: [
                moment(new Date(item.requestedAt)).format('YYYY/MM/DD'),
                moment(new Date(item.requestedAt)).format('hh:mm A'),
              ],
            },
            {
              type: 'TEXT_CELL',
              text: item.locationInfo.locationDisplayCode,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestedNeedles[0].needleNumber,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestedNeedles[0].quantity,
            },
            status === 'APPROVED'
              ? {
                  type: 'TEXT_CELL',
                  text: item.requestedNeedles[0].needleNumber,
                }
              : undefined,
            status === 'APPROVED'
              ? {
                  type: 'TEXT_CELL',
                  text: item.requestedNeedles[0].approved || '0',
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.requestAdditionalInfo || '--',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'CUSTOM_ACTION',
              customTxt: 'needle_request_expand.Expand',
            },
          ]),
        };
      },
    );
  },
};
